export default [
  {
    name: "Popularity",
    value: "-added",
  },
  {
    name: "Name",
    value: "name",
  },
  {
    name: "Realease date",
    value: "-released",
  },
  {
    name: "Rating",
    value: "-rating",
  },
];
